import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "file-input" }
const _hoisted_2 = { class: "icon" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "text" }
const _hoisted_5 = ["accept", "multiple"]

import {HTMLElementEvent} from "@/lib/common/interfaces/event/HtmlElementEvent";


export default /*#__PURE__*/_defineComponent({
  name: 'FileSelector',
  props: {
    icon: null,
    text: null,
    accept: null,
    is_multiple: null
  },
  emits: ['change'],
  setup(__props: any, { emit }) {






const onChange = (e: HTMLElementEvent<HTMLInputElement>) =>
{
  if (!e.target || !e.target.files)
    return;

  const files: File[] = [];

  for (let i = 0; i < e.target.files.length; i++)
  {
    const file = e.target.files[i];

    if (typeof file == "object")
      files.push(file)
  }

  e.target.value = "";

  if (files.length > 0)
    emit("change", files);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _createElementVNode("img", {
          src: __props.icon,
          alt: "icon"
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("span", _hoisted_4, _toDisplayString(__props.text), 1),
      _createElementVNode("input", {
        type: "file",
        accept: __props.accept,
        multiple: __props.is_multiple,
        onChange: onChange
      }, null, 40, _hoisted_5)
    ])
  ]))
}
}

})